import { of } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { LogEntry } from '../logEntry';


export abstract class LogPublisher {
    location: string;
    abstract log(record: LogEntry):
    Observable<boolean>
    abstract clear(): Observable<boolean>;
}